import * as React from "react"

function HeaderSvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={429}
      height={402}
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      {...props}
    >
      <path
        fill="#3a99f3"
        d="M119.5 204.5c2.141-.663 4.475-.997 7-1 3.641-.185 6.974.481 10 2-4.31-.58-8.643-.914-13-1h-4z"
        opacity={0.055}
      />
      <path
        fill="#3a97f2"
        d="M136.5 205.5c1.291-.237 2.291.096 3 1-1.291.237-2.291-.096-3-1z"
      />
      <path
        fill="#5a71e7"
        d="M119.5 204.5h4c-8.362 2.02-15.362 6.353-21 13a25.497 25.497 0 015-7c3.133-3.567 7.133-5.567 12-6z"
      />
      <path
        fill="#4d8bed"
        d="M139.5 206.5c2.174.25 3.841 1.25 5 3-2.174-.25-3.841-1.25-5-3z"
      />
      <path
        fill="#4b7ef5"
        d="M131.5 210.5v1h-11c3.498-1.762 7.165-2.096 11-1z"
      />
      <path
        fill="#625ee5"
        d="M131.5 210.5c3.216-.155 5.883.845 8 3a20.69 20.69 0 00-5-1c-1.291.237-2.291-.096-3-1v-1z"
      />
      <path
        fill="#2da6f5"
        d="M107.5 210.5a25.497 25.497 0 00-5 7c-2.665 2.335-3.998 5.335-4 9 .237 1.291-.096 2.291-1 3-.982 3.462-1.315 7.129-1 11-2.008-9.323-.175-17.99 5.5-26 1.451-1.964 3.284-3.297 5.5-4z"
      />
      <path
        fill="#5180eb"
        d="M120.5 211.5c-9.742 4.589-15.576 12.256-17.5 23-.44-12.398 5.393-20.065 17.5-23z"
      />
      <path
        fill="#6a44de"
        d="M102.5 217.5a55.533 55.533 0 01-4 9c.002-3.665 1.335-6.665 4-9z"
        opacity={0.992}
      />
      <path
        fill="#2e3778"
        d="M133.5 229.5c-6.019-6.752-11.685-6.419-17 1-.126-5.704 2.707-8.704 8.5-9 5.333.169 8.166 2.836 8.5 8z"
        opacity={0.93}
      />
      <path
        fill="#2454b6"
        d="M138.5 222.5c-.667-1.333-.667-1.333 0 0z"
        opacity={0.082}
      />
      <path
        fill="#474fba"
        d="M187.5 229.5c7.008-.166 14.008 0 21 .5 8.861 2.851 13.528 9.018 14 18.5-.044 9.276-4.377 15.442-13 18.5-7.326.5-14.659.666-22 .5v-38zm8 6c15.362-1.594 21.195 5.073 17.5 20a11.532 11.532 0 01-3.5 4.5 34.749 34.749 0 01-14 2.5v-27z"
        opacity={0.939}
      />
      <path
        fill="#464fb9"
        d="M233.5 229.5h9a958.434 958.434 0 0014 39 15.418 15.418 0 01-7-1 45.979 45.979 0 01-4-8.5c-5-.667-10-.667-15 0a98.469 98.469 0 01-4 8.5 15.418 15.418 0 01-7 1l14-39zm4 8c1.973 4.9 3.973 9.9 6 15a31.116 31.116 0 01-11 1l5-16z"
        opacity={0.971}
      />
      <path fill="#474fba" d="M249.5 229.5h31v6h-12v33h-7v-33h-12v-6z" />
      <path
        fill="#4750b9"
        d="M288.5 229.5c2.747-.313 5.414.02 8 1a1255.016 1255.016 0 0115 37c-2.265 1.147-4.598 1.314-7 .5-1.805-2.567-3.138-5.401-4-8.5a64.873 64.873 0 00-16-1 24.046 24.046 0 01-4 9.5c-2.402.814-4.735.647-7-.5a663.113 663.113 0 0015-38zm3 10c.876-.131 1.543.202 2 1a291.312 291.312 0 015 12.5c-4 .667-8 .667-12 0a65.746 65.746 0 005-13.5z"
        opacity={0.968}
      />
      <path
        fill="#2f5cba"
        d="M144.5 209.5c8.165 5.023 12.998 12.356 14.5 22 9.664 8.699 13.497 19.366 11.5 32a326.819 326.819 0 01-15.5-15l-1 2a326.819 326.819 0 00-15.5-15c2.504-4.231 2.504-8.564 0-13 2.79.449 5.456.449 8 0-3.144-4.488-7.144-7.821-12-10a20.69 20.69 0 015 1c5.018 2.688 8.685 6.688 11 12a10.94 10.94 0 014.5 3c.036-3.565-.964-6.898-3-10a98.521 98.521 0 00-7.5-9z"
      />
      <path
        fill="#3b4dba"
        d="M133.5 229.5c-.663 4.771-3.497 7.105-8.5 7-4.351.08-7.184-1.92-8.5-6 5.315-7.419 10.981-7.752 17-1z"
      />
      <path
        fill="#2e8df0"
        d="M320.5 231.5a63.131 63.131 0 0118 1.5c6.855 6.689 6.522 13.023-1 19a45.564 45.564 0 01-14 1.5v14h-3v-36zm3 2a41.047 41.047 0 0113 1.5c5.333 4.667 5.333 9.333 0 14-4.2 1.367-8.533 1.867-13 1.5v-17z"
        opacity={0.899}
      />
      <path
        fill="#2e8ef0"
        d="M347.5 231.5h3v34a73.133 73.133 0 0117 1c-6.634.997-13.3 1.33-20 1v-36z"
        opacity={0.966}
      />
      <path
        fill="#2d8def"
        d="M370.5 231.5h3c-.166 9.006 0 18.006.5 27 4.175 7.369 10.008 8.869 17.5 4.5a29.517 29.517 0 002.5-4.5c.5-8.994.666-17.994.5-27h3c.166 9.339 0 18.673-.5 28-4.983 8.992-12.15 11.159-21.5 6.5-2.117-1.731-3.617-3.898-4.5-6.5-.5-9.327-.666-18.661-.5-28z"
        opacity={0.847}
      />
      <path
        fill="#2e8def"
        d="M408.5 231.5a60.931 60.931 0 0111 .5 8.905 8.905 0 014 3l-1.5 1.5c-3.423-2.68-7.256-3.513-11.5-2.5-3.624 2.161-4.791 5.328-3.5 9.5a131.085 131.085 0 0014.5 7c4.965 7.601 3.299 13.434-5 17.5-5.96 1.4-10.96-.1-15-4.5 2.419-1.395 4.419-.895 6 1.5 3.333.667 6.667.667 10 0 4.291-3.448 4.958-7.448 2-12a204.49 204.49 0 01-13-5.5c-4.412-6.036-3.746-11.369 2-16z"
        opacity={0.91}
      />
      <path
        fill="#5c3ac8"
        d="M112.5 255.5a162.014 162.014 0 00-10.5-11c-1.55 1.091-2.717 2.424-3.5 4v-2-2a206.643 206.643 0 0111.5-14c1.201 3.21 3.201 5.877 6 8 1.315 6.294.148 11.961-3.5 17z"
        opacity={0.947}
      />
      <path
        fill="#394eb9"
        d="M138.5 235.5a326.819 326.819 0 0115.5 15l1-2a326.819 326.819 0 0015.5 15c.011 5.651-1.656 10.651-5 15a2.428 2.428 0 00-.5-2 684.226 684.226 0 00-30.5-29c-1.3-2.524-1.3-5.191 0-8 1.688-1.021 3.021-2.355 4-4z"
        opacity={0.993}
      />
      <path
        fill="#4f82eb"
        d="M97.5 229.5a75.84 75.84 0 001 15v2c-1.574-1.602-2.24-3.602-2-6-.315-3.871.018-7.538 1-11z"
        opacity={0.773}
      />
      <path
        fill="#7829d3"
        d="M112.5 255.5a163.263 163.263 0 01-10 22 27.127 27.127 0 01-4.5-10 65.876 65.876 0 01.5-19c.783-1.576 1.95-2.909 3.5-4a162.014 162.014 0 0110.5 11z"
        opacity={0.99}
      />
      <path
        fill="#4845c0"
        d="M134.5 247.5a684.226 684.226 0 0130.5 29c.464.594.631 1.261.5 2-2.776 5.114-6.776 8.781-12 11a379680.79 379680.79 0 00-19-42z"
      />
      <path
        fill="#5b39c6"
        d="M133.5 263.5a646.012 646.012 0 00-15 2c-1.073-.751-1.24-1.751-.5-3 1.964-4.601 4.631-8.601 8-12a51.867 51.867 0 017.5 13z"
        opacity={0.996}
      />
      <path
        fill="#2e3775"
        d="M133.5 263.5c-4.556 1.942-9.556 2.608-15 2a646.012 646.012 0 0115-2z"
      />
      <path
        fill="#752ad2"
        d="M140.5 279.5a134.736 134.736 0 01-28 .5c-.544-.717-1.211-1.217-2-1.5l3-6a96.54 96.54 0 0124-.5 37.865 37.865 0 013 7.5z"
        opacity={0.991}
      />
      <path
        fill="#4750ba"
        d="M188.5 276.5c1.287 1.371 1.953 3.205 2 5.5l-1 5.5a31.116 31.116 0 01-1-11z"
      />
      <path
        fill="#4751ba"
        d="M262.5 276.5c1.287 1.371 1.953 3.205 2 5.5l-1 5.5a31.116 31.116 0 01-1-11z"
        opacity={0.306}
      />
      <path
        fill="#474fb9"
        d="M284.5 276.5c7.668.007 9.668 3.34 6 10-7.428 2.204-10.262-.463-8.5-8 .995-.566 1.828-1.233 2.5-2zm0 2c5.648-.189 6.982 1.978 4 6.5-1.399.595-2.732.428-4-.5-1.194-2.016-1.194-4.016 0-6z"
        opacity={0.899}
      />
      <path
        fill="#474fbb"
        d="M318.5 276.5a2.428 2.428 0 012 .5 51.064 51.064 0 014 5.5 579.57 579.57 0 015-6c1.333 3.667 1.333 7.333 0 11a20.2 20.2 0 01-1.5-6 26.091 26.091 0 01-3.5 5l-3.5-5a20.2 20.2 0 01-1.5 6 31.116 31.116 0 01-1-11z"
        opacity={0.944}
      />
      <path
        fill="#4344cb"
        d="M333.5 276.5c1.175-.219 2.175.114 3 1-1.552 1.298-2.552.965-3-1z"
      />
      <path
        fill="#4950b8"
        d="M344.5 276.5c1.914 3.184 2.58 6.851 2 11-6.021.927-8.021-1.406-6-7 1.189-.929 2.522-1.262 4-1v-3zm-3 5h3v4h-3v-4z"
        opacity={0.833}
      />
      <path
        fill="#4750b9"
        d="M354.5 276.5h3a31.116 31.116 0 01-1 11c-1.521-.38-3.187-.546-5-.5-3.168-4.161-2.168-6.661 3-7.5v-3zm-2 5c1.086.12 1.753.787 2 2-.804 2.457-1.804 2.457-3 0 .363-.683.696-1.35 1-2z"
        opacity={0.758}
      />
      <path
        fill="#4750ba"
        d="M360.5 276.5c1.287 1.371 1.953 3.205 2 5.5l-1 5.5a31.116 31.116 0 01-1-11z"
      />
      <path
        fill="#474fb9"
        d="M381.5 276.5c3.264 1.427 5.764 3.761 7.5 7 .186-2.4.686-4.734 1.5-7 2.473 12.305.307 13.638-6.5 4a26.724 26.724 0 01-1.5 7 31.116 31.116 0 01-1-11z"
        opacity={0.826}
      />
      <path
        fill="#464fb9"
        d="M205.5 277.5a21.662 21.662 0 004 3c-.825.886-1.825 1.219-3 1-.172 1.992.495 3.658 2 5l-1.5 1c-1.904-1.89-3.07-4.224-3.5-7 1.112-.765 1.779-1.765 2-3z"
        opacity={0.757}
      />
      <path
        fill="#464fb9"
        d="M249.5 277.5c3.887 1.157 4.554 3.157 2 6a7.293 7.293 0 002 3c-1.151 1.231-2.317 1.231-3.5 0-1.063-3.068-1.23-6.068-.5-9z"
        opacity={0.845}
      />
      <path
        fill="#4750b9"
        d="M194.5 279.5c6.732-1.018 8.732 1.648 6 8a9.86 9.86 0 01-1-6h-3a9.86 9.86 0 01-1 6 16.873 16.873 0 01-1-8z"
        opacity={0.861}
      />
      <path
        fill="#464fb9"
        d="M212.5 279.5c3.741-.901 5.741.432 6 4-6.636.522-6.636 1.355 0 2.5-1.833 1.788-3.833 1.954-6 .5-1.214-2.359-1.214-4.692 0-7z"
        opacity={0.913}
      />
      <path
        fill="#4850ba"
        d="M221.5 279.5c1.788-.285 3.455.048 5 1-.825.886-1.825 1.219-3 1a9.86 9.86 0 01-1 6 16.873 16.873 0 01-1-8z"
        opacity={0.988}
      />
      <path
        fill="#4453bb"
        d="M228.5 279.5c2.169.582 4.502.582 7 0a16.873 16.873 0 01-1 8c-1.614-7.898-2.614-7.898-3 0h-3v-8z"
        opacity={0.94}
      />
      <path
        fill="#464fb9"
        d="M240.5 279.5c3.05-.577 5.05.59 6 3.5-7.294.213-7.628 1.213-1 3-2.309 2.051-4.476 1.884-6.5-.5-.748-2.34-.248-4.34 1.5-6z"
        opacity={0.881}
      />
      <path
        fill="#474fb8"
        d="M268.5 279.5c5.676.447 6.009 1.281 1 2.5 1.723.523 3.056 1.523 4 3-1.546 2.386-3.546 2.886-6 1.5 1.489-.033 2.822-.533 4-1.5-3.405-.753-4.405-2.586-3-5.5z"
        opacity={0.833}
      />
      <path
        fill="#4650b9"
        d="M295.5 279.5c1.808 1.418 2.475 3.418 2 6h3a9.86 9.86 0 011-6c1.333 2.667 1.333 5.333 0 8-1.778-.069-3.611-.403-5.5-1a24.935 24.935 0 01-.5-7z"
        opacity={0.957}
      />
      <path
        fill="#464fb9"
        d="M305.5 279.5c1.725.778 3.391 1.111 5 1-2.295 1.7-3.628 4.034-4 7a16.873 16.873 0 01-1-8z"
        opacity={0.773}
      />
      <path
        fill="#4750ba"
        d="M334.5 279.5c1.248.834 1.915 2.167 2 4l-1 4a16.873 16.873 0 01-1-8z"
        opacity={0.894}
      />
      <path
        fill="#464ebb"
        d="M366.5 279.5c3.741-.901 5.741.432 6 4-6.636.522-6.636 1.355 0 2.5-6.081 2.083-8.081-.084-6-6.5z"
        opacity={0.889}
      />
      <path
        fill="#464fb9"
        d="M395.5 279.5c1.644-.214 3.144.12 4.5 1 .497 2.31.663 4.643.5 7-8.176.175-8.842-1.659-2-5.5l-4-1c.556-.383.889-.883 1-1.5zm0 6c.751-1.073 1.751-1.24 3-.5-.852 1.728-1.852 1.895-3 .5z"
        opacity={0.828}
      />
      <path
        fill="#4650b9"
        d="M403.5 279.5c3.699.125 7.365.458 11 1 1.224 2.339 1.224 4.672 0 7a9.86 9.86 0 01-1-6h-3c-.386 7.898-1.386 7.898-3 0a9.86 9.86 0 00-1 6h-3v-8z"
        opacity={0.903}
      />
      <path
        fill="#464ebb"
        d="M419.5 279.5c2.788-.423 4.788.577 6 3-7.854.987-7.854 2.154 0 3.5-3.722 2.49-6.389 1.657-8-2.5l2-4z"
        opacity={0.834}
      />
      <path
        fill="#303677"
        d="M110.5 278.5c.789.283 1.456.783 2 1.5 9.411.805 18.744.638 28-.5-4.451 1.327-9.284 1.994-14.5 2l-14.5-.5c-.752-.671-1.086-1.504-1-2.5z"
      />
    </svg>
  )
}

export default HeaderSvgComponent
